import { defineStore } from 'pinia';
import { Subject } from 'rxjs';
import { getUserInfo, getCompanyInfo, getCompanyShopInfo, getSessionBaseInfo } from '@/api/session';

// 售后创建抽屉打开
const afterSaleCreateOpen$ = new Subject<string | void>();

interface GroupUserInfo {
    nickName: string;
    headImg: string;
    competitionType?: number;
}

type RelatedShopSource = {
    code: string;
    desc: string;
};

export const useSessionStore = defineStore('session', () => {
    // 当前会话ID
    const conversationID = ref<string>();
    // 当前会话用户信息
    const conversationUserInfo = ref<SESSION_API.UserInfo>();
    const conversationMerchantsInfo = ref<SESSION_API.MerchantsInfo>();
    const conversationCompanyShopInfo = ref<SESSION_API.CompanyShopInfo>();
    const groupID = ref<string>();
    const groupUserInfo = ref<GroupUserInfo>();
    const MessageTab = ref<{ type: string; orderId?: string; goodsId?: string }>();
    const sessionBaseInfo = ref<SESSION_API.SessionBaseInfo>();
    const sessionRenderKey = ref<number>(0);
    const sessionID = ref<string>();
    const setConversationID = (id?: string) => {
        conversationID.value = id;
    };

    const setGroupUserInfo = (info: GroupUserInfo) => {
        groupUserInfo.value = info;
    };

    const setGroupID = (id?: string) => {
        groupID.value = id;
    };

    const refreshConversationUserInfo = async (userId?: string | number) => {
        if (userId) {
            conversationUserInfo.value = await getUserInfo({
                userId: userId.toString()
            });
        } else {
            conversationUserInfo.value = undefined;
        }
    };
    const refreshMerchantsInfo = async (params: { userId?: string; userImId?: string }) => {
        if (params.userId) {
            conversationMerchantsInfo.value = await getCompanyInfo(params);
            conversationCompanyShopInfo.value = await getCompanyShopInfo(params);
        } else {
            conversationMerchantsInfo.value = undefined;
            conversationCompanyShopInfo.value = undefined;
        }
    };

    const refreshSessionBaseInfo = async (id?: string) => {
        if (id) {
            sessionBaseInfo.value = await getSessionBaseInfo({
                groupId: id
            });
        } else {
            sessionBaseInfo.value = undefined;
        }
    };

    const getDefaultRelatedShop = async (id?: string): Promise<RelatedShopSource | undefined> => {
        const currentGroupId = id ?? groupID.value;
        if (!currentGroupId) {
            return undefined;
        }

        const baseInfo = await getSessionBaseInfo({
            groupId: currentGroupId
        });
        if (baseInfo?.exchangeInShopId && baseInfo.exchangeInShopName) {
            return {
                code: baseInfo.exchangeInShopId,
                desc: baseInfo.exchangeInShopName
            };
        }

        return undefined;
    };

    const setSessionID = (id?: string) => {
        sessionID.value = id;
    };

    const refreshSessionRenderKey = () => {
        sessionRenderKey.value = sessionRenderKey.value + 1;
    };

    const MessageTabChange = (card: { type: string; orderId?: string; goodsId?: string }) => {
        MessageTab.value = card;
    };

    const openAfterSaleCreate = (orderId?: string) => {
        afterSaleCreateOpen$.next(orderId);
    };

    const getAfterSaleCreateOpen$ = () => afterSaleCreateOpen$;

    return {
        conversationID,
        conversationUserInfo,
        conversationMerchantsInfo,
        groupUserInfo,
        sessionBaseInfo,
        conversationCompanyShopInfo,
        groupID,
        sessionID,
        sessionRenderKey,
        setConversationID,
        setGroupUserInfo,
        setGroupID,
        refreshConversationUserInfo,
        refreshSessionBaseInfo,
        refreshSessionRenderKey,
        MessageTabChange,
        MessageTab,
        getDefaultRelatedShop,
        openAfterSaleCreate,
        getAfterSaleCreateOpen$,
        refreshMerchantsInfo,
        setSessionID
    };
});
